import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import EditNumberStatusDropdown from "./EditNumberStatusDropdown";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const EditNumberStatus = () => {
  const classes = useStyles();

  const [newRangeRequired, setNewRangeRequired] = useState(false);

  const [dataObj, setDataObj] = useState({
    pools: [],
    sites: [],
    ranges: [],
    statuses: [],
    loading: true,
  });

  useEffect(() => {
    Promise.all([
      fetchWithToken("api/Pools"),
      fetchWithToken("api/Sites"),
      fetchWithToken("api/Ranges"),
      fetchWithToken("api/Forms"),
    ])
      .then(([res1, res2, res3, res4]) =>
        Promise.all([res1.json(), res2.json(), res3.json(), res4.json()])
      )
      .then(([data1, data2, data3, data4]) =>
        setDataObj({
          pools: data1,
          sites: data2,
          ranges: data3,
          statuses: data4.numberStatuses,
          loading: false,
        })
      );
  }, []);

  useEffect(() => {
    fetchWithToken("api/Ranges")
      .then((res) => res.json())
      .then((data) => {
        setDataObj((prev) => ({
          ...prev,
          ranges: data,
        }));
      });
  }, [newRangeRequired]);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <EditNumberStatusDropdown
            classes={classes}
            data={dataObj}
            setNewRangeRequired={setNewRangeRequired}
          />
        </div>
      )}
    </>
  );
};

export default EditNumberStatus;
